import { GenericConnector } from "./connector.model";
import { Journey } from "./journey.model";


export interface Board {
  serviceAccount?: string;
  journey: Journey;
  connectors: GenericConnector[];
}
